import { faAndroid, faApple, faInstagram, faTelegram, faWhatsapp, faWindows } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import ContactUs from '../../Components/ContactUs/ContactUs'
import CoursesList from '../../Components/CoursesList/CoursesList'
import Divider from '../../Components/DividerSite/Divider'
import TopNavbar from '../../Components/Navbar/TopNavbar'
import SliderSite from '../../Components/Slider/SliderSite'
import Style from './Home.module.css'
const Home = () => {
    return (
        <div className={`pageHolder`}>
            <TopNavbar/>
            {/* <SliderSite/> */}
            <CoursesList/>
            <Divider title={'درباره ما'}/>
            <section className={Style.TopSection}>
            <div className={Style.FirstLandingContent}>
                <div className={Style.ImageHolder}><img src="/Assets/Images/Regular/contact.jpeg" alt="electronicsteps" /></div>
                <div className={Style.SiteInfo}>
                    <h3>گام به گام با الکترونیک</h3>
                    <p>سایت گام به گام با الکترونیک درصدد آن است که شما عزیزان را با مشکلات انواع بردهای مختلف آشنا سازد و روش شبیه سازی و عیب یابی صحیح و تعمیر بردهای مختلف را به بهترین و آسانترین شکل به شما عزیزان آموزش دهد. باتوجه به اینکه کسب تجربه، از تعمیر بردهای مختلف زمان زیادی از تعمیرکاران خواهد گرفت، هدف ما این است، تجربه ی تخصصی و حرفه ای خود را که حاصل سالیان سال تلاش مجدانه ما در تعمیر بردهای مختلف بوده است، با شما به اشتراک بگذاریم. امید است با یادگیری و بکارگیری این نکات ارزشمند، روند شبیه سازی، عیب یابی و تعمیر بردهای الکترونیکی خود را سرعت بخشید </p>
                </div>
            </div>
            </section>

            <Divider title={'نرم افزار ها'}/>
            <section className={Style.LandingGuid}>
                <img className={Style.ImageHolder} src='/Assets/Images/Regular/guid.jpg' alt='fixboard'/>
                <div className={Style.AppHolder}>
                    <p>برای دانلود نرم افزار روی سیستم عامل خود کلیک کنید:</p>
                    <section className={Style.AppPart}>
                        <a href='https://app.spotplayer.ir/assets/bin/spotplayer/setup.exe' className={Style.App}>
                            <FontAwesomeIcon icon={faWindows}/>
                            <h3>Windows</h3>
                        </a>
                        <a href='https://app.spotplayer.ir/assets/bin/spotplayer/setup.apk' className={Style.App}>
                            <FontAwesomeIcon icon={faAndroid}/>
                            <h3>Android</h3>
                        </a>
                        <a href='https://app.spotplayer.ir/assets/bin/spotplayer/setup.dmg' className={Style.App}>
                            <FontAwesomeIcon icon={faApple}/>
                            <h3>mac</h3>
                        </a>
                    </section>
                </div>
            </section>
            
            <Divider title={'ارتباط با ما'}/>
            <ContactUs/>
            <div className={Style.jahanwebDivision}>
                <p>طراحی سایت و تنظیم توسط: <a href='https://jahaanweb.ir'>Jahaanweb</a></p>
                <div>
                    <a href="https://www.instagram.com/jahaanweb/"><FontAwesomeIcon icon={faInstagram}/></a>
                    <a href="/"><FontAwesomeIcon icon={faWhatsapp}/></a>
                    <a href="/"><FontAwesomeIcon icon={faTelegram}/></a>
                </div>
            </div>
            <p className={Style.copyRight}>Copyright ©  2021-2022 electroniceSteps Company . All rights reserved.</p>
        </div>
    )
}

export default Home
